import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { cn } from '@/utils/cn';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

/**
 * PageTransition Component
 *
 * Wraps page content and provides smooth fade-in animation
 * when navigating between pages.
 *
 * Uses a key-based approach to trigger CSS animation on route change,
 * avoiding the flicker caused by state-based opacity toggling.
 * Also scrolls to top on route change.
 */
export const PageTransition = ({ children, className }: PageTransitionProps) => {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div
      key={location.pathname}
      className={cn(
        'animate-fade-in',
        className
      )}
    >
      {children}
    </div>
  );
};
